// extracted by mini-css-extract-plugin
export default {"list":"ListView_list__cGLpl","tray":"ListView_tray__Fqzbw"};